<template>
  <RevDrawer
    :name="MODAL_NAMES.SEE_MORE_MARGIN"
    :title="i18n(translations.seeMoreMargin)"
  >
    <template #body>
      <div class="flex flex-col gap-12">
        <div>
          <p class="body-1-bold">
            {{ i18n(translations.marginCostIncludesTitle) }}
          </p>
          <ul class="list-inside list-disc">
            <li>
              <span>
                {{ i18n(translations.marginCostIncludesItem1) }}
              </span>
            </li>
            <li>
              <span>
                {{ i18n(translations.marginCostIncludesItem2) }}
              </span>
            </li>
            <li>
              <span>
                {{ i18n(translations.marginCostIncludesItem3) }}
              </span>
            </li>
            <li>
              <span>
                {{ i18n(translations.marginCostIncludesItem4) }}
              </span>
            </li>
          </ul>
        </div>
        <p>
          <span class="body-1-bold mr-4">{{
            i18n(translations.customizationCostTitle)
          }}</span
          ><span>{{ i18n(translations.customizationCostValue) }}</span>
        </p>
        <p>
          <span class="body-1-bold mr-4">{{
            i18n(translations.resellingPriceTitle)
          }}</span
          ><span>{{ i18n(translations.resellingPriceValue) }}</span>
        </p>
        <ul class="list-inside list-disc">
          <li>
            <span class="body-1-bold mr-4">{{
              i18n(translations.lastDays)
            }}</span
            ><span>{{ i18n(translations.lastDaysValue) }}</span>
          </li>
          <li>
            <span class="body-1-bold mr-4">{{
              i18n(translations.condition)
            }}</span
            ><span>{{ i18n(translations.conditionValue) }}</span>
          </li>
        </ul>
        <RevInfoBlock
          class="mb-20"
          :icon="IconWarning"
          :title="i18n(translations.seeMoreMarginInfoBlockTitle)"
          variant="warning"
        >
          <ul class="list-inside list-disc">
            <li>
              <span class="body-2-bold">
                {{ i18n(translations.seeMoreMarginInfoBlockContent1) }}
              </span>
            </li>
            <li>
              <span class="body-2-bold">
                {{ i18n(translations.seeMoreMarginInfoBlockContent2) }}
              </span>
            </li>
            <li>
              <span class="body-2-bold">
                {{ i18n(translations.seeMoreMarginInfoBlockContent3) }}
              </span>
            </li>
          </ul>
        </RevInfoBlock>
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconWarning } from '@ds/icons/IconWarning'

import { MODAL_NAMES } from '~/scopes/buyback/constants'

import translations from './ModalSeeMoreMargin.translations'

const i18n = useI18n()
</script>
